import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const ProblemSection = () => {
    return (
        <Box
            component="section"
            id="solution"
            aria-labelledby="solution-section-heading"
            sx={{
                position: 'relative',
                py: { xs: 7, md: 8, lg: 8.5 },
                background: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 40%, #F5F8FF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.06)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.06)',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 'min(100%, 960px)',
                    height: '280px',
                    background:
                        'radial-gradient(ellipse 70% 55% at 50% 0%, rgba(0, 102, 255, 0.06) 0%, transparent 70%)',
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>    
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        The solution
                    </Typography>
                </Box>
                <Typography
                    id="solution-section-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem', lg: '2.75rem' },
                        fontWeight: 700,
                        lineHeight: 1.22,
                        letterSpacing: '-0.03em',
                        color: '#0F172A',
                        mb: { xs: 3.5, md: 4 },
                        // maxWidth: '22ch',
                    }}
                >
                    Verified sessions. Clean records. Payouts without the negotiation.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        fontWeight: 400,
                        // maxWidth: '42rem',
                        textAlign: 'justify',
                        mb: 2.5,
                    }}
                >
                    Every visit has a location, a time stamp, and a therapist attached to it before the
                    session closes. Session notes are completed on-site, in a structured format that
                    can't be filled in later. The field picture updates in real time. No calls to
                    confirm someone was there.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        fontWeight: 400,
                        // maxWidth: '42rem',
                        textAlign: 'justify',
                        mb: 2.5,
                    }}
                >
                    The record exists before the therapist leaves the patient's home. When the
                    payment cycle closes, there's nothing to argue. The number comes from a verified
                    record. Not from whoever argued harder.
                </Typography>
            </Container>
        </Box>
    );
};

export default ProblemSection;
